import { queryOptions } from '@tanstack/react-query';

import { type BlocksQueryParams, type HardnessRuleQueryParams, hardnessService } from '~api/services';

export const hardnessDomainByBlastQueryOptions = (blastName: string) =>
  queryOptions({
    queryKey: ['hardness_domains', 'blast', blastName],
    queryFn: () => hardnessService.getHardnessDomainByBlast(blastName),
  });

export const blocksQueryOptions = (config?: BlocksQueryParams) =>
  queryOptions({
    queryKey: ['blocks', config ?? {}],
    queryFn: () => hardnessService.getBlocks(config),
  });

export const hardnessRuleQueryOptions = (config: HardnessRuleQueryParams) =>
  queryOptions({
    queryKey: ['hardness_rule', config],
    queryFn: () => hardnessService.getHardnessRuleForBlock(config),
  });
